/** Seed a known-credit amount as negative, or undefined when there is nothing to seed. */
export function asCredit(value: string | null): string | undefined {
  if (!value) {
    return undefined;
  }
  if (Number(value) === 0) {
    return value;
  }
  return value.startsWith('-') ? value : `-${value}`;
}
